module.exports = __webpack_public_path__ + "img/苦涩.d07df1cc.png";